import { useRef } from 'react';
import { useVelList } from '@/hooks/useVelList';
import { useOfferList } from "@/services/useOfferList";
import { useVelPatch } from '@/services/useVelPatch';
import { useOfferAdd } from '@/services/useOfferAdd';
import { useUpload } from '@/services/useUpload';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import OfferRow from './OfferRow';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons';


function Offers({velId}) {
  const upload = useUpload();
  const vels = useVelList();
  const vel = vels.find( v => v.id === +velId )
  const offers = useOfferList({velId});
  const {mutate:velPatch} = useVelPatch({velId});
  const {mutate:offerAdd} = useOfferAdd({velId});
  const inputRef = useRef<HTMLInputElement>(null);

  if( !vel ) 
    return null;

  if( offers.isPending )
    return <p>Chargement</p>

  if( offers.isError )
    return <p>Une erreur est survenue</p>

  const handleOfferSelection = (e, selected) => {
    e.preventDefault();
    if( selected ) {
      velPatch({ offer: selected.id})
    } else {
      velPatch({ offer: null})
    }
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const key = `prod/r2vel/${vel.id}/${Date.now()}-${files[0].name}`
      upload.mutate({file:files[0], key}, {
        onSuccess: (url) => {
          offerAdd({url})
        }
      });
    }
  };

  return (
    <div className="m-4">
      <h1 className="font-bold text-5xl mb-8">Bannières</h1>
      <div className="flex w-full justify-end items-center gap-1.5 mb-2">
        <Button
          type="button"
          variant="default"
          onClick={() => inputRef.current?.click()}
        >
          <FontAwesomeIcon icon={faPlus} />
          Ajouter une bannière...
        </Button>
        <Input
          ref={inputRef}
          id="picture"
          type="file"
          style={{display:'none'}}
          accept="image/*"
          onChange={onFileChange}
        />
      </div>
      <div className="rounded-md border bg-white ">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Id</TableHead>
              <TableHead>Par défaut</TableHead>
              <TableHead>Intitulé</TableHead>
              <TableHead>Image</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {offers.data.map((offer) => (
              <OfferRow key={offer.id} offer={offer} vel={vel} handleOfferSelection={handleOfferSelection}/>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default Offers;
